import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ERROR_PARAM, ERROR_REQUEST_ID_PARAM, parseUUID} from '@npck/libs/commons';
import {Error} from '../../infra/app-error-handler.service';

const ERROR_ICONS: Record<string, string> = {
    [Error.PAGE_NOT_FOUND]: 'ic_404',
    [Error.SERVER_ERROR]: 'ic_500',
};

@Component({
    templateUrl: 'error.component.html',
    styleUrls: ['error.component.scss'],
    standalone: false
})
export class ErrorComponent {
    requestId: string;
    errorTitle: string;
    errorSubtitle: string;
    errorIcon: string;

    constructor(
        private activatedRoute: ActivatedRoute,
    ) {
        const errorFromData = this.activatedRoute.snapshot.data.error;
        const errorParam = this.activatedRoute.snapshot.queryParams[ERROR_PARAM];
        const error = this.errorFromString(errorFromData || errorParam);
        this.requestId = parseUUID(this.activatedRoute.snapshot.queryParams[ERROR_REQUEST_ID_PARAM]);
        this.errorTitle = 'i18n_auth_appErrorTitle#' + error;
        this.errorSubtitle = 'i18n_auth_appErrorSubtitle#' + error;
        this.errorIcon = ERROR_ICONS[error] || 'ic_error';
    }

    private errorFromString(error: string): Error {
        return Object.values(Error).find(it => it === error) || Error.SERVER_ERROR;
    }
}
